import React from 'react';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';

import Tag, { TagProps } from '../Tag';

interface Props extends Omit<TagProps, 'postfix'> {}

const RemovableTag: React.FC<Props> = ({ ...rest }) => {
  return <Tag postfix={<CloseIcon size={IconSize.TINY} />} {...rest} />;
};
RemovableTag.displayName = 'RemovableTag';

export default RemovableTag;
